import { normalizePillFilterValue, isPillFilterActive } from "./screenerStateStorage";
import { REGION_FR_TO_EN } from "./invelpsRegions";

/** Au moins un filtre actif (pills, bool ou range modifié). */
export function hasActiveScreenerFilters(fv, piliers) {
  if (!fv || !piliers) return false;
  for (const pilier of piliers) {
    for (const f of pilier.filters) {
      const v = fv[f.id];
      if (f.type === "pills" && isPillFilterActive(v)) return true;
      if (f.type === "bool" && v !== null) return true;
      if (f.type === "range") {
        const def = f.isMax ? f.max : f.min;
        if (v !== def) return true;
      }
    }
  }
  return false;
}

function appendPillParams(params, key, values, mapRegionFr = false) {
  const picks = normalizePillFilterValue(values);
  picks.forEach((v) => {
    if (mapRegionFr && REGION_FR_TO_EN[v]) {
      params.append(key, REGION_FR_TO_EN[v]);
    } else {
      params.append(key, v);
    }
  });
}

/** Construit les query params pour GET /capitalflow/screener */
export function buildScreenerQueryParams(fv, piliers) {
  const params = new URLSearchParams();
  if (!fv || !piliers) return params;

  const pillKeys = new Set([
    "signal", "moat", "capClass", "region", "country", "sector",
    "structTone", "marcheStatus", "moatStatus", "rrQ", "distSt",
  ]);

  for (const pilier of piliers) {
    for (const f of pilier.filters) {
      const v = fv[f.id];
      if (f.type === "pills" && pillKeys.has(f.id)) {
        appendPillParams(params, f.id, v, f.id === "region");
      } else if (f.type === "bool" && v !== null) {
        params.set(f.id, v === true ? "1" : "0");
      } else if (f.type === "range") {
        const def = f.isMax ? f.max : f.min;
        if (v !== def) params.set(f.id, String(v));
      }
    }
  }
  return params;
}

export async function fetchScreener(baseUrl, fv, piliers) {
  const base = (baseUrl || "").replace(/\/$/, "");
  if (!base) return { rows: [], filterOptions: {}, meta: {} };

  const params = buildScreenerQueryParams(fv, piliers);
  const url = `${base}/capitalflow/screener${params.toString() ? `?${params}` : ""}`;
  const t0 = typeof performance !== "undefined" ? performance.now() : 0;
  const r = await fetch(url);
  if (!r.ok) throw new Error(String(r.status));
  const j = await r.json();
  const elapsedMs =
    typeof performance !== "undefined" ? Math.round(performance.now() - t0) : null;
  return {
    rows: Array.isArray(j.rows) ? j.rows : [],
    filterOptions: j.filterOptions || {},
    meta: { ...(j.meta || {}), elapsedMs },
  };
}
